<template>
  <div class="kpis">
    <StatisticsKpi label="Devis créés" :value="integer(k.created)" hint="Sur la période" />
    <StatisticsKpi label="Devis signés" :value="integer(k.signed)" :hint="`${money(k.signedHt)} HT signés`" />
    <StatisticsKpi label="Taux de signature" :value="percent(k.signatureRate)" hint="Signés sur devis créés, hors annulés" />
    <StatisticsKpi label="Devis refusés" :value="integer(k.refused)" />
    <StatisticsKpi label="Devis en attente" :value="integer(k.pending)" hint="Ni signés ni refusés" />
    <StatisticsKpi label="Montant moyen HT" :value="money(k.averageHt)" hint="Par devis créé" />
    <StatisticsKpi label="Délai moyen de signature" :value="days(k.averageDaysToSign)" hint="Entre la création et la signature" />
  </div>
  <div class="charts">
    <StatisticsCard :span="8" title="Devis par période" subtitle="Créés, signés et refusés le jour de l'événement" :empty="!hasData(eventValues)">
      <StatisticsChart value-format="integer" :labels="labels" :datasets="eventDatasets" />
    </StatisticsCard>
    <StatisticsCard :span="4" title="Issue des devis créés" :empty="!data.outcomes.length">
      <StatisticsChart type="doughnut" value-format="integer" :labels="data.outcomes.map(item => OUTCOMES[item.key].label)" :datasets="[{label: 'Devis', data: data.outcomes.map(item => item.count), colors: data.outcomes.map(item => OUTCOMES[item.key].color)}]" />
    </StatisticsCard>
    <StatisticsCard :span="12" title="Montant des devis créés" subtitle="Chiffre d'affaires potentiel HT, hors devis annulés" :empty="!hasData(data.series.map(row => row.createdHt))">
      <StatisticsChart type="line" :labels="labels" :datasets="[{label: 'Montant HT', data: data.series.map(row => row.createdHt), fill: true}]" height="220px" />
    </StatisticsCard>
  </div>
</template>

<script>
import StatisticsKpi from "@/statistics/components/StatisticsKpi.vue";
import StatisticsCard from "@/statistics/components/StatisticsCard.vue";
import StatisticsChart from "@/statistics/components/StatisticsChart.vue";
import {bucketLabel, days, hasData, integer, money, percent} from "@/statistics/utils/format";
import {NEGATIVE_COLOR, OTHERS_COLOR, PALETTE} from "@/statistics/utils/chartTheme";

const OUTCOMES = {
  SIGNED: {label: 'Signés', color: '#3fbd63'},
  REFUSED: {label: 'Refusés', color: NEGATIVE_COLOR},
  PENDING: {label: 'En attente', color: PALETTE[2]},
  CANCELLED: {label: 'Annulés', color: OTHERS_COLOR},
};

/**
 * Devis : volume, taux de signature et montants.
 */
export default {
  name: 'QuotesStats',
  components: {StatisticsKpi, StatisticsCard, StatisticsChart},
  props: {
    data: {type: Object, required: true},
  },
  data() {
    return {OUTCOMES};
  },
  computed: {
    k() {
      return this.data.kpis;
    },
    labels() {
      return this.data.series.map(row => bucketLabel(row.key));
    },
    eventValues() {
      return this.data.series.flatMap(row => [row.created, row.signed, row.refused]);
    },
    eventDatasets() {
      return [
        {label: 'Créés', data: this.data.series.map(row => row.created), color: PALETTE[0]},
        {label: 'Signés', data: this.data.series.map(row => row.signed), color: OUTCOMES.SIGNED.color},
        {label: 'Refusés', data: this.data.series.map(row => row.refused), color: OUTCOMES.REFUSED.color},
      ];
    },
  },
  methods: {money, integer, percent, days, hasData},
};
</script>

<style lang="stylus" scoped>
@require '~/src/statistics/style/statistics.styl';
</style>
